<span
  class="mandatory-check"
  matTooltip="mandatory check"
  matTooltipPosition="above"
  matTooltipShowDelay="500"
>
  MAN
</span>
